import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.inputMode = "numeric"
    if (!this.element.autocomplete) this.element.autocomplete = "tel"

    this.format()
  }

  format() {
    this.element.value = this.formatPhone(this.element.value)
  }

  formatPhone(value) {
    const digits = String(value || "").replace(/\D/g, "").slice(0, 13)
    if (digits.length === 0) return ""

    const hasCountryCode = digits.startsWith("55") && digits.length > 11
    const nationalDigits = hasCountryCode ? digits.slice(2) : digits
    const formatted = this.formatBrazilianNumber(nationalDigits)

    return hasCountryCode && formatted ? `+55 ${formatted}` : formatted
  }

  formatBrazilianNumber(digits) {
    const value = digits.slice(0, 11)
    const areaCode = value.slice(0, 2)
    const number = value.slice(2)

    if (value.length <= 2) return `(${areaCode}`

    if (number.length <= 4) {
      return `(${areaCode}) ${number}`
    }

    if (number.length <= 8) {
      return `(${areaCode}) ${number.slice(0, 4)}-${number.slice(4)}`
    }

    return `(${areaCode}) ${number.slice(0, 5)}-${number.slice(5, 9)}`
  }
}
